import { rrulestr } from 'rrule';

import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';

const L = logger('recurrenceRuleSet');

const recurrenceRuleSet = withOptions((options) => {
  try {
    return rrulestr(options.string, { forceset: true });
  } catch (e) {
    L.error('()', 'for options:', options, 'error:', e);
    return null;
  }
});

export default recurrenceRuleSet;
